import React from 'react';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';
import { Card, CardContent, CardHeader, CardTitle } from '@roger/ui-components';
import { ShieldX } from 'lucide-react';
import {
  VSPManagement,
  // NarrativeTemplates,
} from '../components/customizations';

const Customizations: React.FC = () => {
  const { hasPermission } = useStore(
    useShallow(state => ({
      hasPermission: state.hasPermission,
    }))
  );

  // Check if user has permission to access Customizations
  if (!hasPermission('customizations:access')) {
    return (
      <Card className='max-w-md mx-auto mt-8'>
        <CardHeader>
          <CardTitle className='flex items-center gap-2 text-destructive'>
            <ShieldX className='h-5 w-5' />
            Access Denied
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className='text-muted-foreground'>
            You don't have permission to access Customizations features. Please
            contact your administrator if you believe this is an error.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-3xl font-bold'>Customizations</h1>
        <p className='text-muted-foreground'>Configure Roger customizations.</p>
      </div>

      <div className='grid gap-6'>
        <VSPManagement />
        {/* Commented out for now, test properly before enabling */}
        {/* <NarrativeTemplates /> */}
      </div>
    </div>
  );
};

export default Customizations;
